import script from "./FloatingWhatsApp.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingWhatsApp.vue?vue&type=script&setup=true&lang=js"

import "./FloatingWhatsApp.vue?vue&type=style&index=0&id=0c503db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c503db8"]])

export default __exports__